// src/components/hotel/HotelAmenities.jsx
import React from 'react';
import styles from './css/HotelAmenities.module.css';

const amenityIcons = {
    'Wi-Fi': 'fa-wifi',
    'Pool': 'fa-swimming-pool',
    'Spa': 'fa-spa',
    'Gym': 'fa-dumbbell',
    'Parking': 'fa-parking',
    'Restaurant': 'fa-cutlery',
    'Bar': 'fa-glass-martini',
    'Room Service': 'fa-concierge-bell',
    'Laundry': 'fa-shirt',
    'Air Conditioning': 'fa-snowflake-o',
    'TV': 'fa-television',
    'Breakfast': 'fa-coffee',
    'Pet Friendly': 'fa-paw',
    'Beach Access': 'fa-umbrella-beach',
    'Concierge': 'fa-bell',
    'Business Center': 'fa-briefcase',
    'Airport Shuttle': 'fa-bus',
    'Kitchen': 'fa-cutlery',
    'Balcony': 'fa-building-o',
    'Fireplace': 'fa-fire',
};

const getAmenityIcon = (amenity) => {
    return amenityIcons[amenity] || 'fa-check-circle';
};

const HotelAmenities = ({ amenities }) => {
    return (
        <div className={styles.hotelAmenities}>
            <div className={styles.amenitiesHeader}>
                <h2 className={styles.amenitiesTitle}>
                    <span className={styles.titleIcon}><i className="fa fa-star-o" /></span>
                    Hotel Amenities
                </h2>
                <span className={styles.amenitiesCount}>{amenities?.length || 0} amenities</span>
            </div>

            {amenities?.length > 0 ? (
                <div className={styles.amenitiesGrid}>
                    {amenities.map((amenity, index) => (
                        <div key={index} className={styles.amenityItem}>
                            <div className={styles.amenityIcon}>
                                <i className={`fa ${getAmenityIcon(amenity)}`} />
                            </div>
                            <span className={styles.amenityName}>{amenity}</span>
                        </div>
                    ))}
                </div>
            ) : (
                <div className={styles.noAmenities}>
                    <div className={styles.noAmenitiesIcon}><i className="fa fa-bed" /></div>
                    <p>No amenities listed for this hotel.</p>
                </div>
            )}
        </div>
    );
};

export default HotelAmenities;
